import Subscription from "../../default-components/subscription/Subscription";
import AddSubscription from "../../default-components/subscription/AddSubscription";

import "./PGSubscription.scss";
const PGSubscription = () => {
  return (
    <div className="subscription-page-parent-div">
      <Subscription />
      <AddSubscription />
    </div>
  );
};

export default PGSubscription;
